// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-j_bC","storyDetailHeaderDescription__time":"c-j_bE"};